import { useQueryClient } from '@tanstack/react-query';

import type { QueryClient } from '@tanstack/react-query';

export const useInvalidateQuery = () => {
  const queryClient = useQueryClient();

  const invalidateQuery: QueryClient['invalidateQueries'] = (...args) =>
    queryClient.invalidateQueries(args);

  const refetchQuery: QueryClient['refetchQueries'] = (...args) =>
    queryClient.refetchQueries(args);

  const refreshQuery = async (options: {
    queryKey: any[];
    exact?: boolean;
  }) => {
    await queryClient.invalidateQueries(options);
    await queryClient.refetchQueries(options);
  };

  return {
    invalidateQuery,
    refetchQuery,
    refreshQuery,
  };
};
